var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5138 0C17.96 0 19.9964 1.97862 19.9964 5.33786V5.37513H15.7618C13.7911 5.37859 12.1947 6.93514 12.1911 8.85657C12.1884 10.7823 13.7867 12.3458 15.7618 12.3484H20V12.6543C20 16.0136 17.9636 18 14.5173 18H5.48356C2.03644 18 0 16.0136 0 12.6543V5.33786C0 1.97862 2.03644 0 5.48356 0H14.5138ZM10.3831 3.8749H4.73956C4.32 3.87664 3.97956 4.20858 3.97777 4.61852C3.976 5.03019 4.31733 5.36559 4.73956 5.36733H10.3902C10.8124 5.36559 11.1538 5.03019 11.152 4.61765C11.1502 4.20598 10.8053 3.87318 10.3831 3.8749Z",
    fill: "#2042B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0374 9.29669C14.2465 10.2479 15.0805 10.9171 16.0326 10.8997H19.2825C19.6787 10.8997 20 10.5716 20 10.1661V7.63452C19.9992 7.22985 19.6787 6.90089 19.2825 6.90002H15.9561C14.8731 6.90351 13.9983 7.80247 14 8.9103C14 9.03997 14.0128 9.16964 14.0374 9.29669Z",
    fill: "#2042B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.90002C16.5523 9.90002 17 9.45231 17 8.90002C17 8.34774 16.5523 7.90002 16 7.90002C15.4477 7.90002 15 8.34774 15 8.90002C15 9.45231 15.4477 9.90002 16 9.90002Z",
    fill: "#2042B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.4f935caa690fb0d67a207af46a990e51.svg";
export { ForwardRef as ReactComponent };